import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Contacts',
  basePath: '/contacts',
  columns: [
    { key: 'contact_email', label: 'Email', sortable: true },
    { key: 'contact_first_name', label: 'First Name', sortable: true },
    { key: 'contact_last_name', label: 'Last Name', sortable: true },
    { key: 'contact_phone', label: 'Phone', sortable: true },
    { key: 'contact_position', label: 'Position', sortable: true },
    { key: 'contact_valid', label: 'Valid', sortable: true,
      render: (v) => v == 1 ? 'Yes' : 'No' },
    { key: 'role_name', label: 'Role', sortable: true },
  ],
  fields: [
    { key: 'contact_email', label: 'Email', type: 'text', required: true },
    { key: 'contact_first_name', label: 'First Name', type: 'text' },
    { key: 'contact_last_name', label: 'Last Name', type: 'text' },
    { key: 'contact_phone', label: 'Phone', type: 'text' },
    { key: 'contact_position', label: 'Position', type: 'text' },
    { key: 'contact_valid', label: 'Valid', type: 'yesno', defaultValue: '1' },
    { key: 'role_id', label: 'Role', type: 'async-select',
      optionsUrl: '/contacts-roles/options',
      placeholder: 'Select role' },
  ],
  filters: [
    { key: 'client', label: 'Client', type: 'select',
      optionsUrl: '/clients/options' },
  ],
  defaultSort: { field: 'contact_last_name', dir: 'asc' },
});
